<!-- =========================================================================================
  File Name: EditCourse.vue
  Description: User Edit Page

========================================================================================== -->

<template>
  <div id="page-user-edit">

    <vs-alert color="danger" title="Simulation Not Found" :active.sync="errorOccurred">
      <span>Course record with id: {{ $route.params.simulationId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'admin-list-simulation'}" class="text-inherit underline">All Simulations</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="simulation_data">

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Details" icon-pack="feather" icon="icon-edit">
              <simulations-details-tab class="mt-4" :data="simulation_data" v-on:update_simulation_data="update_simulation_data" :key="refresh_key"/>
          </vs-tab>
          <vs-tab label="Properties" icon-pack="feather" icon="icon-settings">
              <simulations-legacy-tab class="mt-4"  v-if="simulation_legacy_data" :data="simulation_legacy_data" v-on:simulation_legacy_update_data="simulation_legacy_update_data"/>
              <h4 v-else>Not Enabled</h4>
          </vs-tab>
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import SimulationsDetailsTab from './SimulationsDetailsTab'
import SimulationsLegacyTab from './SimulationsLegacyTab'


export default {
  components: {
    SimulationsDetailsTab,
    SimulationsLegacyTab
  },
  data () {
    return {
      simulation_data: null,
      simulation_legacy_data: null,
      errorOccurred: false,

      refresh_key: 0,

      difficulties: [
        {id: '0', label: 'Simple'},
        {id: '1', label: 'Easy'},
        {id: '2', label: 'Moderate'},
        {id: '3', label: 'Hard'},
        {id: '4', label: 'Challenging'}
      ],

      activeTab: 0
    }
  },
  watch: {
    activeTab () {
      this.load_simulation_data(this.$route.params.simulationId)
    }
  },
  methods: {
    load_simulation_data () {
      this.$http.get(`simulations/${this.$route.params.simulationId}`)
        .then(response => {

          if (response.status === 200) {
            this.simulation_data = response.data.data
            this.simulation_data.difficulty = this.difficulties.find((x) => parseInt(x.id) === parseInt(response.data.data.difficulty))
            this.refresh_key++

            if (response.data.data.type === 'legacy') {
              this.load_simulation_legacy_data(this.$route.params.simulationId)
            }

          }
        })
        .catch(error => {
          this.errorOccurred = true
          this.error_msg = error

        })
    },
    load_simulation_legacy_data () {
      this.$http.get(`simulations/legacy/${this.$route.params.simulationId}`)
        .then(response => {

          if (response.status === 200) {
            this.simulation_legacy_data = response.data.data

          }

        })
        .catch(() => {
          return this.$vs.notify({
            title: 'Failed To Get Legacy Data',
            text: 'Please contact an admin for more details',
            color: 'danger',
            position: 'top-right'
          })
        })
    },
    update_simulation_data (data) {

      const pl = data
      pl.status = data.status === undefined ? 'active' : data.status
      pl.difficulty = parseInt(data.difficulty.id)

      if (pl.name === undefined) {
        return this.$vs.notify({
          title: 'Failed to update simulation',
          text: 'Please provide a Simulation Name',
          color: 'danger',
          position: 'top-right'
        })
      }

      this.$vs.loading()

      this.$http.post(`simulations/${this.$route.params.simulationId}`, pl)
        .then(response => {

          if (response.status === 200) {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Updated Simulation Successfully',
              text: `Simulation ${  pl.name  } has been updated.`,
              color: 'success',
              position: 'top-right'
            })
            this.load_simulation_data(this.$route.params.simulationId)
          }

        })
        .catch(exception => {
          this.$vs.loading.close()

          let error = 'An unknown error occurred while updating this simulation'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            title: 'Failed to update simulation',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })
    },
    simulation_legacy_update_data (data) {

      const pl = data

      this.$vs.loading()

      this.$http.post(`simulations/legacy/${this.$route.params.simulationId}`, pl)
        .then(response => {
          this.$vs.loading.close()
          if (response.status === 200) {
            this.$vs.notify({
              title: 'Updated Simulation Properties Successfully',
              text: 'Simulation Properties has been updated.',
              color: 'success',
              position: 'top-right'
            })
            this.load_simulation_legacy_data(this.$route.params.simulationId)
          }

        })
        .catch(exception => {
          this.$vs.loading.close()

          let error = 'An unknown error occurred while updating simulation properties'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            title: 'Failed to update simulation properties',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })
    }

  },
  created () {
    this.load_simulation_data(this.$route.params.simulationId)
  }
}

</script>
